import { useCallback, useEffect, useState } from 'react';

type PreviewLoader = () => Promise<{ eligibleCount: number; canClear?: boolean }>;

export function useMaintenanceCleanupEligibility(
  enabled: boolean,
  loadPreview: PreviewLoader,
  refreshSignal: unknown = null,
) {
  const [eligibleCount, setEligibleCount] = useState(0);
  const [loading, setLoading] = useState(enabled);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setEligibleCount(0);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const result = await loadPreview();
      setEligibleCount(result.eligibleCount ?? 0);
    } catch {
      setEligibleCount(0);
    } finally {
      setLoading(false);
    }
  }, [enabled, loadPreview]);

  useEffect(() => {
    void refresh();
  }, [refresh, refreshSignal]);

  return {
    eligibleCount,
    loading,
    canClear: !loading && eligibleCount > 0,
    refresh,
  };
}
